import { render, staticRenderFns } from "./DocEditor.vue?vue&type=template&id=a68e3c80&scoped=true&"
import script from "./DocEditor.vue?vue&type=script&lang=ts&"
export * from "./DocEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DocEditor.vue?vue&type=style&index=0&id=a68e3c80&prod&scoped=true&lang=sass&"
import style1 from "./DocEditor.vue?vue&type=style&index=1&id=a68e3c80&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68e3c80",
  null
  
)

export default component.exports